import { disableAnimation } from './disable-animation'
import { setTableWrapper } from './table-wrap'
import { sidebarToggler } from './sidebar'
import { toggleSeoText } from './seo-text'
import { anchors } from './anchors'

document.addEventListener('DOMContentLoaded', () => {
  disableAnimation()
  setTableWrapper()
  sidebarToggler()
  toggleSeoText()
  anchors()
}, { passive: true })
